import { useEffect } from "react";
import { MapContainer, Polygon, TileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { pontasOrdenadas } from "../../../utils/geometria";

const TILES = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
const ATRIBUICAO = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

// Enquadra o polígono inteiro, com folga.
function Enquadrar({ posicoes }) {
  const map = useMap();
  useEffect(() => {
    if (posicoes.length) map.fitBounds(posicoes, { padding: [24, 24], maxZoom: 18 });
    // Dentro de um modal o mapa nasce antes de ter tamanho: recalcula.
    const t = setTimeout(() => { map.invalidateSize(); if (posicoes.length) map.fitBounds(posicoes, { padding: [24, 24], maxZoom: 18 }); }, 150);
    return () => clearTimeout(t);
  }, [map, posicoes]);
  return null;
}

/**
 * Mapa SÓ DE LEITURA com o polígono de uma área registrada (modal do plantio).
 * Zoom e arraste continuam livres para a pessoa olhar de perto, mas nada é editável.
 */
export default function MapaAreaLeitura({ coordenadas, altura = 280 }) {
  const posicoes = pontasOrdenadas(coordenadas).map((p) => [p.lat, p.lng]);
  if (posicoes.length < 3) return null;

  return (
    <div className="mapa-area-leitura" style={{ height: altura, borderRadius: 12, overflow: "hidden", border: "1px solid #EFF0F2" }}>
      <MapContainer center={posicoes[0]} zoom={15} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false} aria-label="Mapa da área registrada">
        <TileLayer url={TILES} attribution={ATRIBUICAO} maxZoom={19} />
        <Enquadrar posicoes={posicoes} />
        <Polygon positions={posicoes} pathOptions={{ fillColor: "#D7E3DA", fillOpacity: 0.7, color: "#3E8E5B", weight: 3 }} />
      </MapContainer>
    </div>
  );
}
